import { Box, Typography, styled } from '../../../../base';
import { keyframes, Theme } from '@mui/material';

const fadeBorder = (theme: Theme) => keyframes`
  0% {
    border-color: ${theme.palette.secondary.main}33;
  }
  50% {
    border-color: ${theme.palette.secondary.main}CC;
  }
  100% {
    border-color: ${theme.palette.secondary.main}33;
  }
`;

export const MessageContainer = styled(Box, {
    shouldForwardProp: (prop) =>
        prop !== 'isAssistant' && prop !== 'isAwaitingReply',
})<{ isAssistant: boolean; isAwaitingReply?: boolean }>(
    ({ theme, isAssistant, isAwaitingReply }) => ({
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
        padding: isAssistant ? theme.spacing(2) : theme.spacing(1),
        marginBottom: theme.spacing(1),
        textAlign: 'start',
        border: isAssistant
            ? `1px solid ${theme.palette.secondary.main}`
            : 'none',
        borderRadius: isAssistant ? theme.shape.borderRadius : 0,
        animation: isAwaitingReply
            ? `${fadeBorder(theme)} 1.5s infinite`
            : 'none',
    })
);

export const AvatarContainer = styled(Box)(({ theme }) => ({
    marginInlineEnd: theme.spacing(2),
}));

export const TextContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
});

export const AuthorTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    marginBottom: theme.spacing(0.5),
}));

export const MessageTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));
